var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnedriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3119 11.4035L21.885 6.19701C20.7274 1.78732 16.1296 -0.870554 11.6155 0.26041C9.58282 0.769646 7.81729 2.00058 6.66357 3.71295C6.74974 3.71089 16.3119 11.4035 16.3119 11.4035Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2956 4.69323L10.2954 4.69416C9.23046 4.04992 8.00232 3.70936 6.74968 3.71094C6.72079 3.71094 6.69231 3.71269 6.66341 3.713C2.93752 3.75813 -0.0455629 6.74539 0.000526966 10.3852C0.0172648 11.7055 0.439559 12.9905 1.21268 14.0735L9.56211 13.052L15.9634 8.00968L10.2956 4.69323Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8848 6.19709C21.7616 6.1886 21.6381 6.1841 21.5146 6.1836C20.767 6.18286 20.0271 6.33204 19.3409 6.62189L19.3407 6.62137L15.9634 8.00971L19.6866 12.5025L26.3428 14.0831C27.7793 11.4782 26.7819 8.22895 24.1153 6.82568C23.4262 6.46312 22.6657 6.24872 21.8848 6.19709Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.21289 14.0735C1.83402 14.9458 2.66204 15.6584 3.62625 16.1503C4.59047 16.6422 5.66222 16.8988 6.75 16.8983H21.515C22.5049 16.8985 23.4765 16.6369 24.3265 16.1413C25.1766 15.6456 25.8734 14.9344 26.3431 14.0832L15.9636 8.00952L1.21289 14.0735Z",
    fill: "#28A8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedriveIcon);
export default __webpack_public_path__ + "static/media/onedrive-icon.48df5a0cf2e8b8860bc2165bf7270aa9.svg";
export { ForwardRef as ReactComponent };